module.exports = __webpack_public_path__ + "static/scale-model-of-adventure-mammoth-in-washington-d.c.-d128dc4681397d6bb9dc87e94da63fa1.png";